import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBoolVal, hasAccess, objectToFormData } from "../../utils";
import { trips, userTrips } from "./../../actions/trips/trips";
import PageHeader from "./../PageHeader";
import Table from "../Common/Table/Table";
import { message } from "antd";
import { useHistory, useLocation } from "react-router";
import moment from 'moment';

const Trips = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [tripsData, setTripsData] = React.useState([]);
  const tripsResponse = useSelector((state) => state.trips.trips || {});
  const userTripsResponse = useSelector((state) => state.trips.userTrips || {});
  const [page, setPage] = React.useState(1);
  const is_admin = useSelector(
    (state) => state?.auth?.localVariables?.is_admin,
  );

  const addUserTripResponse = useSelector(
    (state) => state.trips.addUserTrip || {},
  );
  const [filters, setFilters] = React.useState({});

  const labels = {
    covered: "closed",
  };

  const columns = [
    {
      title: "Trip ID",
      dataIndex: "number",
      key: "number",
      render: (text, record) => {
        return (
          <div
            className={`cursor render_common_style status_${record?.status}`}
          >
            {text}
          </div>
        );
      },
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      key: "employee_name",
    },
    {
      title: "Trip Name",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Trip Type",
      dataIndex: "trip_type",
      key: "trip_type",
    },
    {
      title: "Purpose",
      dataIndex: "purpose",
      key: "purpose",
      width: "200px",
      render: (text) => {
        return (
          <div>
            {text?.length > 199 ? text?.substring(0, 200) + ". . ." : text}
          </div>
        );
      },
    },
    {
      title: "Created On",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => (
        <div>{text ? moment(text, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY, HH:mm:ss") : "-"}</div>
      ),
    },
    {
      title: "Submitted On",
      dataIndex: "submitted_on",
      key: "submitted_on",
      render: (text) => (
        <div>{text ? moment(text, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY, HH:mm:ss") : "-"}</div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => (
        <div
          className={`status status_${is_admin ? record?.current_trip_status : labels[text] ? labels[text] : text}`}
        >
          {is_admin
            ? record?.current_trip_status?.replace(/_/g, " ")
            : labels[text]
              ? labels[text].replace(/_/g, " ")
              : text.replace(/_/g, " ")}
        </div>
      ),
    },
  ];

  React.useEffect(() => {
    if (location?.state?.filter) {
      handleFilter(location?.state?.filter);
    } else {
      getBoolVal(sessionStorage.getItem("is_admin"))
        ? dispatch(trips({ page: 1 }))
        : dispatch(userTrips({ page: 1 }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const {
      data: { response: { trips: tripsList = [] } = {}, status = false } = {},
    } = tripsResponse;
    if (status) {
      setTripsData(tripsList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tripsResponse]);

  React.useEffect(() => {
    const {
      data: { response: { trips: tripsList = [] } = {}, status = false } = {},
    } = userTripsResponse;
    if (status) {
      setTripsData(tripsList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userTripsResponse]);

  React.useEffect(() => {
    const { data: { status = false, message: res_message = "" } = {} } =
      addUserTripResponse;
    if (status) {
      dispatch(userTrips(objectToFormData({ status: true })));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUserTripResponse]);

  const handleRowClick = (evt, record) => {
    evt.preventDefault();
    if (record) {
      history.push({
        pathname: `/trip-details/${record.id}`,
        state: { tripData: record, filter: filters.status },
      });
    }
  };

  const handleAddButton = () => {
    history.push({ pathname: `/add-trip/` });
  };

  const handleFilter = (value) => {
    if (value === "true") {
      getBoolVal(sessionStorage.getItem("is_admin"))
        ? dispatch(trips({}))
        : dispatch(userTrips({}));
      setFilters({
        ...filters,
        status: "",
      });
    } else {
      getBoolVal(sessionStorage.getItem("is_admin"))
        ? dispatch(trips({ ...filters, status: value }))
        : dispatch(userTrips({ ...filters, status: value }));
      setFilters({
        ...filters,
        status: value,
      });
    }
    setPage(1);
  };

  const handleSearch = (value) => {
    getBoolVal(sessionStorage.getItem("is_admin"))
      ? dispatch(trips({ ...filters, search_key: value }))
      : dispatch(userTrips({ ...filters, search_key: value }));

    setFilters({
      ...filters,
      search_key: value,
    });
    setPage(1);
  };

  const common = [
    { label: "All Trips", filter: "true" },
    { label: "Pending Approval", filter: "pending_approval" },
    { label: "Approved", filter: "approved" },
    { label: "Rejected", filter: "rejected" },
    { label: "Closed", filter: "closed" },
    { label: "Cancelled", filter: "cancelled" },
  ];
  return (
    <>
      <div className="heading-div">
        <PageHeader
          title={`Trips`}
          navigation={{
            Home:
              hasAccess("dashboard", "read") || hasAccess("dashboard", "write")
                ? "/dashboard"
                : "",
            Trips: "/trips/",
          }}
        />
      </div>
      <Table
        rowKey="id"
        columns={columns}
        data={tripsData}
        handleRowClick={handleRowClick}
        handleFilter={handleFilter}
        handleSearch={handleSearch}
        placeholder={"Search By Trip ID, Name"}
        isTopFilter={true}
        handleAddButton={handleAddButton}
        is_admin={sessionStorage.getItem("is_admin")}
        module="Trip"
        dotMenu={["trip_name", "submitted_on", "purpose"]}
        pagination={{
          total:
            (getBoolVal(sessionStorage.getItem("is_admin"))
              ? tripsResponse?.data?.total_records
              : userTripsResponse?.data?.total_records) || 0,
          showSizeChanger: false,
          current: page,
          onChange: (pagee) => {
            getBoolVal(sessionStorage.getItem("is_admin"))
              ? dispatch(trips({ page: pagee, ...filters }))
              : dispatch(userTrips({ page: pagee, ...filters }));
            setPage(pagee);
          },
        }}
        handleSort={(key) => {
          // if (key === "purpose") {
          //   key = "destination"
          // }
          getBoolVal(sessionStorage.getItem("is_admin"))
            ? dispatch(trips({ ...filters, sort_key: key }))
            : dispatch(userTrips({ ...filters, sort_key: key }));
          setFilters({
            ...filters,
            sort_key: key,
          });
          setPage(1);
        }}
        activeButton={location?.state?.filter}
        topFilters={
          is_admin
            ? common
            : [...common, { label: "Unsubmitted", filter: "unsubmitted" }]
        }
      />
    </>
  );
};

export default Trips;
